import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';


class EmployeeShop extends ChemComponent {
  	constructor(props) {
		super(props);
		
		var search = {
			BILLING_ID: null
		};

		// initialize employee shop list
		var initialEmployeeShopList = this.copyTable(employeeShopList);
		initialEmployeeShopList.query.search = this.constructSearch(search);

		this.state = {
			employeeShopList: initialEmployeeShopList,
			search: search,
			searchCount: 0,
			renderKey: 1
		};
	}
	
	componentDidMount() {
		var self = this;
		
		this.ajax({
			type: 'post',
			url: this.getConfig().host + '/CRS/Search',
			data: {
				__RequestVerificationToken: this.props.user.antiForgeryToken,
				entity: 'CURRENT_CYCLE_VW',
				pageNumber: -1,
				pageSize: -1
			}
		}).done(function (data) {
			if (data.Success) {
				if (data.Data.length === 1) {
					self.mergeState({ 
						cycleBegDate: self.getDate(data.Data[0].BEG_DATE).toLocaleDateString('en-US', {year:'2-digit', month:'2-digit', day:'2-digit'}),
						cycleEndDate: self.getDate(data.Data[0].END_DATE).toLocaleDateString('en-US', {year:'2-digit', month:'2-digit', day:'2-digit'}),
						renderKey: self.state.renderKey + 1
					});
				} else {
					self.showAlert('Cycle Error', 'Expected 1 current billing cycle but found ' + data.Data.length);
				}
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});		
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}
	
	onSubmitSearch(event) {
		var newEmployeeShopList = this.copyTable(employeeShopList);
		newEmployeeShopList.query.search = this.constructSearch(this.state.search);
		newEmployeeShopList.hold = false;
		this.mergeState({ 
			employeeShopList: newEmployeeShopList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	constructSearch(data) {
		return { Attribute: 'BILLING_ID', Operator: '=', LongValue: data.BILLING_ID };
	}

	render() {

		var exportEmployeeShopData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Employee Shop Report',
			columns: employeeShopExportColumns,
			entity: 'RECHARGES.EMPLOYEE_SHOP_VW',
			search: this.constructSearch(this.state.search),
			order: 'JOBNO'
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Employee Shop Report</span>
					<div style={{ paddingBottom: '10px' }}>Current billing cycle {this.state.cycleBegDate} - {this.state.cycleEndDate}</div>
					<ChemEdit parent={this} columns={employeeShopSearch} data={this.state.search} renderKey={this.state.renderKey} 
					  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} onSubmit={(event) => this.onSubmitSearch(event)} {...this.props}>
					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={4} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportEmployeeShopData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
								</OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportEmployeeShopData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
								</OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						  <Button id="update" variant="warning" type="submit" className="float-end">Search</Button>
						</Col>
					  </Form.Group>
					</ChemEdit>
				  </Col>
				</Row>
				<Row>
				  <Col>
				    <QueryTable renderKey={this.state.renderKey} parent={this} name='CRS_EmployeeShopReport' table={this.state.employeeShopList}
					  onResult={(data) => this.onSearchResult(data)} offsetHeight='220px' />
				  </Col>
				</Row>
			</Container>
		</>);
	}
}

const employeeShopSearch = [
	{ Header: 'Billing Cycle', accessor: 'BILLING_ID', type: 'select', row: 0, col: 0, required: true,
		options: { value: 'BILLING_ID', label: 'BEG_DATE', entity: 'RECHARGES.BILLING_CYCLE_SELECT_VW', order: 'BILLING_ID desc' }},
];

const employeeShopList = {
	query: { entity: 'RECHARGES.EMPLOYEE_SHOP_VW', search: null, order: 'JOBNO' },
	pageSize: 20,
	hold: true,
	columns: [
		{ Header: 'Job No.', accessor: 'JOBNO', width: 70 },
		{ Header: 'Line No.', accessor: 'LINE_ID', width: 70 },
		{ Header: 'Service Name', accessor: 'SERVICE_NAME', width: 200 },
		{ Header: 'Shop Employee', accessor: 'EMP_NAME', width: 200 },
		{ Header: 'Cost Center', accessor: 'COST_CENTER', width: 110 },
		{ Header: 'Description', accessor: 'DESCRIPTION', width: 400 },
		{ Header: 'Labor Hours', accessor: 'LABOR_HOURS', width: 100 },
		{ Header: 'Trans. Date', accessor: 'TRANS_DATE', width: 75 },
		{ Header: 'Bill Date', accessor: 'DATE_BILLED', width: 75 },
		{ Header: 'PI Name', accessor: 'PI_NAME', width: 200 },
	]
};

const employeeShopExportColumns = [
	{ Header: 'Job No.', accessor: 'JOBNO', width: 14 },
	{ Header: 'Line No.', accessor: 'LINE_ID', width: 14 },
	{ Header: 'Service Name', accessor: 'SERVICE_NAME', width: 40 },
	{ Header: 'Shop Employee', accessor: 'EMP_NAME', width: 40 },
	{ Header: 'Cost Center', accessor: 'COST_CENTER', width: 22 },
	{ Header: 'Description', accessor: 'DESCRIPTION', width: 80 },
	{ Header: 'Labor Hours', accessor: 'LABOR_HOURS', width: 20 },
	{ Header: 'Trans. Date', accessor: 'TRANS_DATE', width: 15, format: 'mm-dd-yy' },
	{ Header: 'Bill Date', accessor: 'DATE_BILLED', width: 15, format: 'mm-dd-yy' },
	{ Header: 'PI Name', accessor: 'PI_NAME', width: 40 },
];

export default withRouter(EmployeeShop);